const existingHandlebars = (window as any).Handlebars;

const Handlebars =
  existingHandlebars ||
  require('../../../assets/javascripts/3rdparty/shared/handlebars.min-v4.7.7.js');

export default Handlebars;
